export default "__VITE_ASSET__BIa8ncw7__"